<template>
  <b-form @submit="onSubmit">
    <b-form-group
      id="input-group-lastname"
      label="Nom"
      label-for="input-lastname"
    >
      <b-form-input
        id="input-lastname"
        v-model="form.par_lastname"
        type="text"
        required
      />
    </b-form-group>

    <b-form-group
      id="input-group-firstname"
      label="Prénom"
      label-for="input-firstname"
    >
      <b-form-input
        id="input-firstname"
        v-model="form.par_firstname"
        type="text"
        required
      />
    </b-form-group>

    <b-form-group
      id="input-group-gender"
      label="Genre"
      label-for="input-gender"
    >
      <b-form-select
        id="input-gender"
        v-model="form.par_is_male"
        :options="genders"
      />
    </b-form-group>

    <b-form-group
      id="input-group-birthday"
      label="Anniversaire"
      label-for="input-birthday"
    >
      <b-form-input
        id="input-birthday"
        v-model="form.par_birthday"
        type="date"
        format="DD/MM/YYYY"
      />
    </b-form-group>
<!-- 
    <b-form-group id="input-group-gir" label="GIR" label-for="input-gir">
      <b-form-input
        id="input-gir"
        v-model="form.par_gir"
        type="number"
        min="1"
        max="6"
      />
    </b-form-group>

    <b-form-group
      id="input-group-ss_num"
      label="Numéro de Sécurité Sociale"
      label-for="input-ss_num"
    >
      <b-form-input
        id="input-ss_num"
        v-model="form.par_ss_num"
        type="number"
        length="13"
      />
    </b-form-group> -->

    <b-form-group
      id="input-group-misc"
      label="Commentaire"
      label-for="input-misc"
    >
      <b-form-textarea id="input-misc" v-model="form.par_misc" />
    </b-form-group>
    <b-form-checkbox
      id="checkbox-is_enable"
      switch
      v-model="form.pare_is_enable"
      >Actif</b-form-checkbox
    >
    <b-form-checkbox
      id="checkbox-is_delete"
      switch
      v-model="form.pare_is_delete"
      >Supprimé</b-form-checkbox
    >
    <p class="float-right">
      <b-button type="close" @click="onCancel">Annuler</b-button>
      <b-button type="submit" variant="primary">Valider</b-button>
    </p>
  </b-form>
</template>

<script>

import { getParticipant}  from '../../services/participants'

export default {
  name: "FormParticipant",
  props: {
    esta: {
      type: Number,
      default: null,
    },
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      form: {
        esta_id: null,
        par_id: "",
        par_lastname: "",
        par_firstname: "",
        par_birthday: "",
        par_is_male: "",
        par_misc: "",
        pare_is_enable: true,
        pare_is_delete: false
      },
      genders: [
        { text: "Homme", value: true },
        { text: "Femme", value: false },
      ],
    };
  },
  async created() {
    const data = await getParticipant(this.esta, this.id);
    if (data) this.form = data;

  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.$emit("sendForm", JSON.stringify(this.form));
    },
    onCancel(evt) {
      evt.preventDefault();
      this.$emit("sendCancel");
    },
  },
};
</script>

<style scoped>

</style>>
